import api from './index';

const getPreferenceFile = () => api.get(`/emailing_users/preference-file`);

export { getPreferenceFile };
